import { useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * PageTransition - DISABLED for React 19 Concurrent Mode compatibility
 * CSS transitions can desync fiber tree during concurrent renders
 */
export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  return <>{children}</>;
}
